import { boot } from "quasar/wrappers";
import { Frontegg } from "@frontegg/vue";
import { FronteggAppOptions } from "@frontegg/types";
import { PluginOptions } from "@frontegg/vue/dist/interfaces";
import { LocalizationOverrides } from "@frontegg/types/Localizations/LocalizationOverrides";

// type CustomLocalizationsOverrides = {
//   localization: {
//     string: LocalizationOverrides;
//   }
// };

type CustomLocalizationsOverrides = {
  localizations?: {
    [key: string]: LocalizationOverrides;
  };
};

type ExtendedOptions = PluginOptions & Omit<FronteggAppOptions, "localizations"> & CustomLocalizationsOverrides;

const tenants = {
  webhuset: {
    locale: "no",
  },
};

export default boot(({ router, app }) => {
  const currentTenant = "webhuset";
  const currentTenantData = tenants[currentTenant];

  if (!process.env.FRONTEGG_BASEURL) {
    throw new Error("FRONTEGG_BASEURL is missing from config");
  }

  if (!process.env.FRONTEGG_CLIENT_ID) {
    throw new Error("FRONTEGG_CLIENT_ID is missing from config");
  }

  window.localStorage.setItem("frontegg-language", currentTenantData.locale);
  //const t = app.config.globalProperties.$t;

  const options: ExtendedOptions = {
    //customLoader: true,
    contextOptions: {
      baseUrl: process.env.FRONTEGG_BASEURL,
      clientId: process.env.FRONTEGG_CLIENT_ID,
      //logLevel: "warn",

      // tenantResolver: () => {
      //   // const urlQueryParams = new URLSearchParams(window.location.search);
      //   // const organization = urlQueryParams.get('organization');
      //   return {
      //     tenant: currentTenant
      //   }
      // },
    },
    authOptions: {
      keepSessionAlive: true,
      enableSessionPerTenant: true,
    },
    entitlementsOptions: { enabled: true },
    themeOptions: {
      adminPortal: {
        layout: {
          fullScreenMode: false,
        },
      },
    },
    // localizations: {
    //   no: {
    //     loginBox: {
    //       login: {
    //         emailInputLabel: t("auth.emailInputLabel")
    //       },
    //     },
    //   },
    // },
    hostedLoginBox: false,
    router,
  };

  app.use(Frontegg, options);
});
